import React, { useState, useContext } from "react";
import { useMediaQuery } from "react-responsive";
import "./Navbar.css";

import {
  HamburgerButton,
  SiteHeader,
  SiteLogo,
  SiteLogoContainer,
  SiteMenu,
  SiteMenuLinks,
} from "./styles";

import { MenuLinks } from "./MenuLinks";
import NavItem from "./NavItem";

import gcLogo from "../../assets/images/gc_logo.png";

import { AuthContext } from "../../AuthContext";
import Button from "../Button";
import { deviceSizesMin } from "../../DeviceSizes";

function Navbar() {
  const { userLoggedIn, user } = useContext(AuthContext);

  const isLargeScreen = useMediaQuery({
    query: deviceSizesMin.laptop,
  });

  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  const actionButton = (
    <Button
      href={!userLoggedIn ? "/login" : "/account"}
      style={
        isLargeScreen
          ? { position: "absolute", right: "40px" }
          : { marginTop: "10px" }
      }
    >
      {!userLoggedIn ? "Login" : "My Account"}
    </Button>
  );

  if (click) {
    document.body.classList.add("noscroll");
  } else {
    document.body.classList.remove("noscroll");
  }

  return (
    <SiteHeader>
      <SiteMenu>
        <SiteLogoContainer href="/">
          <SiteLogo src={gcLogo} />
          <span className="logo-text">Gup&apos;s Corner</span>
        </SiteLogoContainer>

        <HamburgerButton.Wrapper onClick={handleClick}>
          <HamburgerButton.Lines active={click} />
        </HamburgerButton.Wrapper>

        <SiteMenuLinks showMobileMenu={click}>
          {MenuLinks.map((menuLink, index) => {
            return <NavItem menuLink={menuLink} key={index} />;
          })}

          {!isLargeScreen ? actionButton : null}
        </SiteMenuLinks>

        {isLargeScreen ? actionButton : null}
      </SiteMenu>
    </SiteHeader>
  );
}

export default Navbar;
